import DomainCommon from './common';

const getApiWithPromise = url => new Promise((resolve, reject) => DomainCommon.fetchGet({url, resolve, reject}));

const apiPrefix = `${DomainCommon.getUecareApiUrl()}/ui/callCenter/calendar`;

const NewCalenderService = {
    fetchEventsMonthly: ({year, month}) => getApiWithPromise(`${apiPrefix}/year/${year}/month/${month + 1}`),
    fetchEventsDaily: ({year, month, date}) => getApiWithPromise(`${apiPrefix}/year/${year}/month/${month + 1}/date/${date}`),
    addWorkEvent: ({workEventType, payload}) => new Promise((resolve, reject) => DomainCommon.fetchPut({
        url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/workEvent/add/${workEventType}`,
        jsonBody: payload,
        resolve, reject,
    })),
    deleteWorkEvent: (id) => new Promise((resolve, reject) => DomainCommon.fetchDelete({
        url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/workEvent/${id}`,
        resolve, reject,
    })),
    exportCalendar: ({dateFrom, dateTo}) => new Promise((resolve, reject) => DomainCommon.fetchPost({
        url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/calendar/exportCalendar`,
        jsonBody: {dateFrom, dateTo},
        resolve, reject,
    })),
};

export default NewCalenderService;



// WEBPACK FOOTER //
// ./src/service/new-calender.js